if (!customElements.get('malfini-basic-129-options')) {
  customElements.define('malfini-basic-129-options', class extends HTMLElement {
    static notesByProduct = new Map();
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.basePrice = Number(this.dataset.basePrice);
      this.variantSku = this.dataset.variantSku;
      this.colorName = this.dataset.colorName;
      this.info = this.closest('product-info');
      this.form = document.getElementById(this.dataset.formId);
      this.disabledUploadInputs = new Map();
      this.notes = this.querySelector('[data-personalization-notes]');
      this.referencePicker = this.querySelector('[data-reference-picker]');
      if (this.referencePicker) {
        this.referencePicker.addEventListener('click', event => {
          const button = event.target.closest('button[data-reference-value]');
          if (!button || !this.referencePicker.contains(button)) return;
          const option = button.dataset.referenceOption;
          const select = this.info?.querySelector(`variant-selects select[name="options[${option}]"]`);
          if (!select || ![...select.options].some(item => item.value === button.dataset.referenceValue)) return;
          select.value = button.dataset.referenceValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          if (option === 'Colore') {
            this.colorName = select.value;
            this.updateGallery();
          }
          this.renderReferencePicker();
        }, options);
      }
      if (this.notes) this.notes.value = this.constructor.notesByProduct.get(this.dataset.productId) || '';
      this.addEventListener('input', (event) => {
        if (event.target === this.notes) this.constructor.notesByProduct.set(this.dataset.productId, this.notes.value);
      }, options);
      if (this.form) {
        this.uploadObserver = new MutationObserver(() => this.syncUploadInputs());
        this.uploadObserver.observe(this.form, { childList: true, subtree: true });
      }
      this.quantity = this.info?.querySelector('input[name="quantity"]');
      this.quantityValue = Number(this.quantity?.value || 1);
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'it', {
        style: 'currency', currency: this.dataset.currency || 'EUR'
      });
      this.addEventListener('change', (event) => {
        const input = event.target;
        if (input.checked && ['heart', 'front'].includes(input.dataset.print)) {
          const other = input.dataset.print === 'heart' ? 'front' : 'heart';
          const alternative = this.querySelector(`[data-print="${other}"]`);
          if (alternative) alternative.checked = false;
        }
        this.updateSummary();
      }, options);
      const updateQuantity = (event) => {
        if (event.target.name === 'quantity') {
          this.quantity = event.target;
          this.quantityValue = Number(event.target.value);
          this.updateSummary();
        }
      };
      this.info?.addEventListener('input', updateQuantity, options);
      this.info?.addEventListener('change', updateQuantity, options);
      this.form?.addEventListener('submit', async (event) => {
        if (this.sourceVariant?.available === false) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.info?.querySelector('product-form')?.handleErrorMessage(this.dataset.unavailableLabel);
          return;
        }
        {
          const personalized = this.isPersonalized();
          event.preventDefault();
          event.stopImmediatePropagation();
          const message = this.querySelector('[data-checkout-message]');
          const native = this.info?.querySelector('product-form');
          const cart = window.MalfiniBasicCart;
          if ((personalized && (this.dataset.quoteOnly === 'true' || !this.querySelector('[data-print]:checked'))) || this.dataset.personalizedCheckoutReady !== 'true' || !cart?.ready()) {
            native?.handleErrorMessage(message.textContent);
            message.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            return;
          }
          if (this.adding) return;
          this.adding = true;
          try {
            native?.handleErrorMessage();
            this.enforcePrintRules();
            const positions = personalized ? [...this.querySelectorAll('[data-print]:checked')].map(input => input.dataset.print) : [];
            await cart.add(this.form, positions);
          } catch (error) {
            native?.handleErrorMessage(error.message);
          } finally { this.adding = false; }
        }
      }, { ...options, capture: true });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== this.dataset.sectionId) return;
          this.basePrice = data.variant ? Number(data.variant.price) : null;
          this.variantSku = data.variant?.sku;
          this.colorName = this.info?.querySelector('variant-selects select[name="options[Colore]"]')?.value || data.variant?.option1;
          this.renderReferencePicker();
          this.updateGallery();
          this.quantity = this.info?.querySelector('input[name="quantity"]');
          if (this.quantity) this.quantity.value = String(this.quantityValue);
          this.updateSummary();
        });
      }
      window.MalfiniCommerce?.load().then(() => this.restoreSelection()).catch(() => {});
      this.updateSummary();
      this.updateGallery();
      if (this.dataset.catalogUrl) {
        fetch(this.dataset.catalogUrl, { signal: this.controller.signal }).then(response => {
          if (!response.ok) throw new Error('catalog');
          return response.json();
        }).then(catalog => {
          this.sourceProduct = catalog.products?.find(product => product.shopifyId === 'gid://shopify/Product/' + this.dataset.productId);
          this.renderReferencePicker();
          this.updateSummary();
        }).catch(() => {});
      }
    }
    restoreSelection() {
      const saved = window.MalfiniCommerce.selection(this.dataset.productId, this.variantSku);
      if (!saved) return;
      const mode = this.querySelector('[data-mode="' + (saved.mode === 'printed' ? 'personalized' : 'neutral') + '"]');
      if (mode) mode.checked = true;
      for (const input of this.querySelectorAll('[data-print]')) input.checked = saved.positions.includes(input.dataset.print);
      if (this.notes) {
        this.notes.value = saved.notes;
        this.constructor.notesByProduct.set(this.dataset.productId, saved.notes);
      }
      this.quantityValue = saved.quantity;
      if (this.quantity) this.quantity.value = saved.quantity;
      this.updateSummary();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribeVariant?.();
      this.uploadObserver?.disconnect();
      for (const input of this.disabledUploadInputs?.keys() || []) input.disabled = false;
      this.disabledUploadInputs?.clear();
    }
    updateGallery() {
      window.MalfiniColorGallery?.mountNative(this.info, {
        model: this.dataset.modelCode, colorName: this.colorName, url: this.dataset.galleryUrl
      });
    }
    renderReferencePicker() {
      if (!this.referencePicker || !this.sourceProduct || !this.info) return;
      const selects = [...this.info.querySelectorAll('variant-selects select')];
      const colorSelect = selects.find(select => select.name === 'options[Colore]');
      const sizeSelect = selects.find(select => select.name === 'options[Taglia]');
      if (!colorSelect || !sizeSelect) return;
      const palette = {'00':'#ffffff','01':'#202024','02':'#202b44','03':'#c7c7c5','04':'#ffdd21','05':'#23549c','06':'#224b39','07':'#be2630','08':'#d6c6a6','09':'#7b7860','11':'#f57820','12':'#737474','13':'#cb182e','14':'#572643','15':'#70b9d0','16':'#59a063','17':'#0b4255','18':'#262f52','19':'#555848','21':'#c7b296','27':'#e9ccc8','28':'#69c7c2','29':'#549749','30':'#e0d695','31':'#efce6d','36':'#747a7e','39':'#727269','40':'#deddd9','43':'#5d4c53','44':'#be533c','47':'#458685','49':'#beb0a0','51':'#ef8fba','60':'#73845a','62':'#728580','64':'#506d6b','67':'#79949e','69':'#81818c','70':'#006d9e','71':'#879087','81':'#611e3d','86':'#672a37','87':'#19334a','88':'#aeb6a6','90':'#ca1e70','92':'#beec3c','93':'#a7d4e8','95':'#20332e','96':'#efee40','A1':'#ed8172','A2':'#fa892f','A7':'#dfe9e4','C9':'#9aa98e','D1':'#bf9ebe'};
      const color = this.sourceProduct.colors?.find(item => item.name === colorSelect.value);
      const variant = this.sourceProduct.variants?.find(item => item.color === color?.code && item.size === sizeSelect.value);
      const colors = this.referencePicker.querySelector('[data-reference-colors]');
      const sizes = this.referencePicker.querySelector('[data-reference-sizes]');
      if (!colors.children.length) {
        for (const item of this.sourceProduct.colors || []) {
          if (![...colorSelect.options].some(option => option.value === item.name)) continue;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'malfini-reference-picker__swatch';
          button.dataset.referenceOption = 'Colore';
          button.dataset.referenceValue = item.name;
          button.style.backgroundColor = palette[item.code] || '#a8a8a8';
          button.setAttribute('aria-label', item.name);
          button.title = item.name;
          colors.append(button);
        }
      }
      if (!sizes.children.length) {
        for (const option of sizeSelect.options) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'malfini-reference-picker__size';
          button.dataset.referenceOption = 'Taglia';
          button.dataset.referenceValue = option.value;
          button.textContent = option.value;
          sizes.append(button);
        }
      }
      for (const button of colors.children) {
        const item = this.sourceProduct.colors.find(colorItem => colorItem.name === button.dataset.referenceValue);
        const present = this.sourceProduct.variants?.some(variantItem => variantItem.color === item?.code && variantItem.size === sizeSelect.value);
        button.disabled = !present;
        button.title = present ? item.name : `${item.name} · scegli un'altra taglia`;
        button.setAttribute('aria-label', button.title);
        button.setAttribute('aria-pressed', String(button.dataset.referenceValue === colorSelect.value));
      }
      for (const button of sizes.children) {
        const present = this.sourceProduct.variants?.some(item => item.color === color?.code && item.size === button.dataset.referenceValue);
        button.disabled = !present;
        button.setAttribute('aria-pressed', String(button.dataset.referenceValue === sizeSelect.value));
      }
      this.referencePicker.querySelector('[data-reference-color]').textContent = colorSelect.value;
      this.referencePicker.querySelector('[data-reference-sku]').textContent = variant?.sku ? `SKU ${variant.sku}` : '';
      this.referencePicker.hidden = false;
      this.info.classList.add('malfini-reference-ready');
    }
    isPersonalized() {
      return Boolean(this.querySelector('[data-mode="personalized"]')?.checked);
    }
    enforcePrintRules() {
      const product = this.sourceProduct;
      const hasZip = product?.has_zip === true || /\b(?:zip|zipper|cernier[ae])\b/i.test([product?.name, product?.spec, product?.description].join(' '));
      if (this.dataset.frontAllowed === 'false' || hasZip) {
        const front = this.querySelector('[data-print="front"]');
        if (front) {
          front.checked = false;
          front.disabled = true;
          const label = front.closest('label');
          if (label) label.hidden = true;
        }
        return false;
      }
      return true;
    }
    updateSourceNote() {
      const note = this.querySelector('[data-source-note]');
      const property = this.querySelector('[data-outlet-property]');
      if (!note || !property) return;
      const product = this.sourceProduct;
      const variant = product?.variants.find(item => item.sku === this.variantSku);
      this.sourceVariant = variant;
      property.disabled = true;
      property.value = '';
      note.hidden = true;
      if (!variant) return;
      if (variant.available === false) {
        note.textContent = this.dataset.unavailableLabel;
        note.hidden = false;
        return;
      }
      if (variant.outlet === true && variant.outlet_verified === true && variant.price < product.standard_price && Math.round(variant.price * 100) === this.basePrice) {
        const color = product.colors.find(item => item.code === variant.color)?.name || variant.color;
        property.value = 'Outlet · ' + color + ' · ' + variant.size;
        property.disabled = false;
        note.textContent = this.dataset.outletLabel + ' · ' + color + ' · ' + variant.size + '. ' + this.dataset.standardLabel + ' ' + this.formatter.format(product.standard_price);
        note.hidden = false;
      }
    }
    syncUploadInputs() {
      if (!this.form) return;
      const personalized = this.isPersonalized();
      const selected = new Set([...this.querySelectorAll('[data-print]:checked')].map(input => input.dataset.print));
      const upload = this.form.querySelector('[data-malfini-upload]');
      if (upload) upload.hidden = !personalized || !selected.size;
      this.dataset.modeActive = personalized ? 'personalized' : 'neutral';
      const names = {'File fronte':'front','File retro':'back','File lato cuore':'heart','File braccio destro':'right_arm','File braccio sinistro':'left_arm','File fronte 10x10':'small_front'};
      for (const wrapper of this.form.querySelectorAll('.cl-upload--wrapper')) {
        const name = wrapper.querySelector('input[name^="properties["]')?.name.match(/^properties\[(.+)\]$/)?.[1];
        const ids = {clikhljptfd7:'front',clsqlg3wdahj:'back',clups6uxonbx:'heart',clh7ujysbxb4:'right_arm',cl1mbphs1bwm:'left_arm',clqzbdzcb3ov:'small_front'};
        const position = names[name] || ids[wrapper.id] || wrapper.dataset.basicPrintPosition;
        if (position) wrapper.dataset.basicPrintPosition = position;
        const active = Boolean(position) && personalized && selected.has(position);
        wrapper.hidden = !active;
        for (const input of wrapper.querySelectorAll('input[name]')) input.disabled = !active;
      }
    }
    updateSummary() {
      const personalized = this.isPersonalized();
      this.querySelector('[data-print-panel]').hidden = !personalized;
      this.querySelector('[data-notes-panel]').hidden = !personalized || this.dataset.quoteOnly === 'true';
      this.querySelector('[data-neutral-note]').hidden = personalized;
      this.querySelector('[data-print-cost-row]').hidden = !personalized;
      const frontAllowed = this.enforcePrintRules();
      if (this.notes) this.notes.disabled = !personalized;
      const selected = [...this.querySelectorAll('[data-print]:checked')];
      const printPrice = personalized ? selected.reduce((sum, input) => sum + Number(input.dataset.price), 0) : 0;
      const property = this.querySelector('[data-print-property]');
      property.disabled = !personalized;
      property.value = selected.map(input => input.dataset.label).join(', ');
      const basePrice = this.basePrice;
      const rawQuantity = this.quantityValue;
      const valid = Number.isFinite(basePrice) && basePrice >= 0 && Number.isInteger(rawQuantity) && rawQuantity > 0;
      const write = (selector, price) => {
        this.querySelector(selector).textContent = valid ? this.formatter.format(price / 100) : '—';
      };
      write('[data-garment-price]', basePrice);
      write('[data-print-price]', printPrice);
      write('[data-unit-total]', basePrice + printPrice);
      write('[data-total]', (basePrice + printPrice) * rawQuantity);
      if (personalized && this.dataset.quoteOnly === 'true') {
        for (const selector of ['[data-print-price]', '[data-unit-total]', '[data-total]']) this.querySelector(selector).textContent = this.dataset.quoteLabel;
      }
      this.querySelectorAll('[data-print]').forEach(input => { input.disabled = !personalized || (input.dataset.print === 'front' && !frontAllowed); });
      this.syncUploadInputs();
      this.updateSourceNote();
    }
  });
}

